import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "item"
};
const _hoisted_3 = {
  class: "score"
};
const _hoisted_4 = {
  class: "score"
};
const _hoisted_5 = {
  class: "score"
};
const _hoisted_6 = {
  class: "score"
};
const _hoisted_7 = {
  class: "score"
};
const _hoisted_8 = {
  class: "score"
};
const _hoisted_9 = {
  class: "score"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString($props.item), 1), _createElementVNode("div", _hoisted_3, _toDisplayString($props.score1), 1), _createElementVNode("div", _hoisted_4, _toDisplayString($props.score2), 1), _createElementVNode("div", _hoisted_5, _toDisplayString($props.score3), 1), _createElementVNode("div", _hoisted_6, _toDisplayString($props.score4), 1), _createElementVNode("div", _hoisted_7, _toDisplayString($props.score5), 1), _createElementVNode("div", _hoisted_8, _toDisplayString($props.score6), 1), _createElementVNode("div", _hoisted_9, [$props.isSum ? (_openBlock(), _createBlock(_component_el_input, {
    key: 0,
    "model-value": $props.score,
    size: "medium",
    readonly: ""
  }, null, 8, ["model-value"])) : (_openBlock(), _createBlock(_component_el_input, {
    key: 1,
    modelValue: _ctx.scoreV,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.scoreV = $event),
    size: "medium",
    onChange: $setup.handleChange
  }, null, 8, ["modelValue", "onChange"]))])]);
}